"use client";

import styled from "styled-components";

//components
import Card from "../card";

export const BoxCard = styled(Card)`
  padding: 0;
`;

export const TitleCard = styled.h2`
  font-family: "Inter Medium";
  font-size: 18px;
  color: var(--colorTitle);
  padding: 15px 1.5rem;
  border-bottom: 1px solid var(--borderGraySearch);
  width: 100%;
`;
